@if (items.length === 0) {
  <div class="p-3">
    {{ 'catalog.news.no_items' | transloco }}
  </div>
}
@for (item of items; track item; let last = $last) {
  <div class="p-3">
    <cat-news-item [item]="item"></cat-news-item>
    @if (!last) {
      <mat-divider class="mt-3"></mat-divider>
    }
  </div>
}
